const FacetState = {
  storageKey: 'facet_open_state',

  save() {
    const openGroups = [];
    document.querySelectorAll('#FacetFiltersContainer details').forEach((detail, index) => {
      if (detail.hasAttribute('open')) {
        openGroups.push(index);
      }
    });
    sessionStorage.setItem(this.storageKey, JSON.stringify(openGroups));
  },

  restore() {
    const saved = sessionStorage.getItem(this.storageKey);
    if (!saved) return;

    const openGroups = JSON.parse(saved);
    document.querySelectorAll('#FacetFiltersContainer details').forEach((detail, index) => {
      if (openGroups.includes(index)) {
        detail.setAttribute('open', '');
      } else {
        detail.removeAttribute('open');
      }
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  // Gendan tilstand ved sideload
  FacetState.restore();

  // Gem tilstand når et filter åbnes/lukkes
  document.addEventListener('click', (e) => {
    if (e.target.closest('#FacetFiltersContainer summary')) {
      // Lille timeout så 'open' attributten når at blive sat
      setTimeout(() => FacetState.save(), 50);
    }
  });

  // Gem tilstand når et filter-checkbox klikkes (før AJAX)
  document.addEventListener('click', (e) => {
    if (e.target.closest('#FacetFiltersContainer input[type="checkbox"]')) {
      FacetState.save();
    }
  });

  // Lyt efter AJAX-opdatering af filterbeholderen
  const container = document.querySelector('#FacetFiltersContainer');
  if (container) {
    const observer = new MutationObserver(() => {
      FacetState.restore();
    });

    observer.observe(container, { childList: true, subtree: true });
  }
});